export default __webpack_public_path__ + "static/media/avatar9.87a5a046.jpg";